import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SistemaNotas from './SistemaNotas.jsx';
import FrequenciaEscolar from './FrequenciaEscolar.jsx';
import CalendarioEscolar from './CalendarioEscolar.jsx';
import Turmas from './Turmas.jsx';
import CronogramaEscolar from './CronogramaEscolar.jsx';
import RelatoriosIA from './RelatoriosIA.jsx';
import OrganizacaoProfessor from './OrganizacaoProfessor.jsx';

const pageData = {
  notas: {
    title: 'Sistema de Notas',
    description: 'Gerencie as notas dos alunos de forma eficiente e intuitiva. O sistema permite lançamento rápido, cálculos automáticos e geração de relatórios detalhados.'
  },
  frequencia: {
    title: 'Frequência Escolar',
    description: 'Controle de frequência completo com registro em tempo real, relatórios de ausências e alertas automáticos para pais e responsáveis.'
  },
  calendario: {
    title: 'Calendário Escolar',
    description: 'Visualize e gerencie todos os eventos escolares, feriados, provas e atividades em um calendário interativo e fácil de usar.'
  },
  relatorios: {
    title: 'Relatórios por IA',
    description: 'Gere relatórios inteligentes e personalizados usando inteligência artificial. Análises detalhadas sobre desempenho, frequência e comportamento dos alunos.'
  },
  organizacao: {
    title: 'Organização do Professor',
    description: 'Ferramentas completas para organização da rotina docente: planejamento de aulas, materiais didáticos, anotações e muito mais.'
  },
  cronograma: {
    title: 'Cronograma Escolar',
    description: 'Planeje e acompanhe o cronograma de atividades, conteúdos programáticos e prazos importantes do ano letivo.'
  },
  turmas: {
    title: 'Turmas',
    description: 'Gerencie turmas, alunos e professores. Organize informações de cada turma de forma centralizada e eficiente.'
  },
  atividades: {
    title: 'Atividades',
    description: 'Crie, distribua e corrija atividades de forma digital. Sistema completo de gestão de tarefas e avaliações.'
  },
  boletins: {
    title: 'Boletins',
    description: 'Gere boletins escolares profissionais com todas as informações acadêmicas dos alunos de forma automática e personalizada.'
  },
  simulados: {
    title: 'Simulados',
    description: 'Crie e aplique simulados online com correção automática e análise de desempenho detalhada por aluno e turma.'
  },
  inmessage: {
    title: 'InMessage',
    description: 'Sistema de comunicação integrado para mensagens entre professores, alunos, pais e gestores escolares.'
  }
};

const PageContent = ({ pageId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/${pageId}`);
        setData(response.data);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setData({ message: pageData[pageId]?.title || 'Página', data: null });
      } finally {
        setLoading(false);
      }
    };

    if (pageId) {
      fetchData();
    }
  }, [pageId]);

  const page = pageData[pageId];

  if (!page) {
    return null;
  }

  return (
    <section className="page-section">
      <div className="page-content">
        {pageId === 'notas' ? (
          <SistemaNotas />
        ) : pageId === 'frequencia' ? (
          <FrequenciaEscolar />
        ) : pageId === 'calendario' ? (
          <CalendarioEscolar />
        ) : pageId === 'turmas' ? (
          <Turmas />
        ) : pageId === 'cronograma' ? (
          <CronogramaEscolar />
        ) : pageId === 'relatorios' ? (
          <RelatoriosIA />
        ) : pageId === 'organizacao' ? (
          <OrganizacaoProfessor />
        ) : (
          <>
            <h2>{page.title}</h2>
            <p>{page.description}</p>
            {loading ? (
              <p style={{ marginTop: '20px', color: '#6b7280' }}>Carregando dados...</p>
            ) : data && (
              <div style={{ marginTop: '30px', padding: '20px', background: '#f3f4f6', borderRadius: '8px' }}>
                <p><strong>Status da API:</strong> {data.message || 'Conectado'}</p>
                {data.data && Array.isArray(data.data) && data.data.length > 0 && (
                  <p><strong>Itens encontrados:</strong> {data.data.length}</p>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default PageContent;
